import "pixi.js";
import BaseComponent from "./BaseComponent";
import Physics from "./Physics";
import GameSprite from "./GameSprite";
import C_Entity from "../../const/C_Entity";
import FlierLogic from "./FlierLogic";
import MathUtil from "../utils/MathUtil";
import C_Ships from "../../const/C_Ships";
import C_GameEvt from "../const/C_GameEvent";
import Point3D from "../math/Point3D";


class ProjectileLogic extends BaseComponent
{


    constructor(botId = null)
    {
        super();
        this.app = PIXI.app;
        this.botId = botId;
        this.target = null;

        this.lifeTime = 0;
        this.timeBeforeAutoTarget = 6;
        this.minAngleVelocityChange = 0.01;
        this.targetHit = false;
        this.active = true;
    }


    init()
    {
        super.init();
        this.physics = this.getEntity().getComponent(Physics);
    }


    /**
     * @returns FlierLogic
     */
    getTarget()
    {
        return this.target;
    }


    postPhysicsUpdate(delta)
    {
        this.lifeTime += delta;

        let p = this.getEntity().getComponent(Physics);

        if (p.collisions.length > 0)
        {
            for (let collIdx=0; collIdx < p.collisions.length; collIdx++)
            {
                let collidingEntity = p.collisions[collIdx];
                let flierLogic = collidingEntity.getComponent(FlierLogic);
                let isBomb = flierLogic.shipType == C_Ships.FLARE;

                if (collidingEntity.type == C_Entity.FLIER && this.active == true)
                {
                    this.active = false;

                    if (!this.botId)
                    {
                        if (this.app.controller.serverOnline == true)
                        {
                            this.app.controller.fire(this.getId(), collidingEntity.getId(), flierLogic.getFlierServerId(), isBomb);
                        }
                        else
                        {
                            let chance = flierLogic.shipType != C_Ships.MOTHER_OF_THE_MOONS ? 0.08 : 0.02;
                            if (Math.random() < chance)
                            {
                                this.app.controller.sendFakeResponse(collidingEntity.getId(), isBomb);
                            }
                        }
                    }
                    else
                    {
                        if (Math.random() < 0.05 && flierLogic.shipType != C_Ships.MOTHER_OF_THE_MOONS && flierLogic.shipType != C_Ships.FLARE)
                        {
                            flierLogic.kill(false, this.botId);
                            this.app.model.getBot(this.botId).addToBalance();
                        }
                    }

                    p.physicsActive = false;

                    let s = this.getEntity().getComponent(GameSprite);
                    s.playProjectileSplash();
                    // beam logic
                    this.target = collidingEntity.getComponent(Physics);
                    if (this.hoverBall)
                    {
                        this.finishBeamAnim();
                    }
                    else if (!this.targetHit)
                    {
                        this.targetHit = true;
                    }

                    this.delayedQueueForRemoval(1);
                }
            }

            p.collisions.length = 0;
        }

        if (p.physicsActive)
        {
            let t = this.getTarget();

            if (t)
            {
                let e = t.getEntity();
                let l = e.getComponent(FlierLogic);

                if (l.isAlive() && !e.isRemoved)
                {
                    this.updateVelocity(delta);
                }
                else
                {
                    this.target = null;
                    p.lockedTarget = null; // if there is locked target and its dead, we should clean it
                    this.acquireTarget();
                }
            }
            else
            {
                // this.acquireTarget();
                this.initialAcquireTarget();
            }
        }

        this.setProjectileRotation();
        this.moveSplashInFront();

        this.executeBeamWeaponLogic();
    }


    moveSplashInFront()
    {
        if (this.target && !this.active)
        {
            let z = this.target.position.z - 0.01;
            this.physics.position.z = z;
            this.getEntity().getComponent(GameSprite).sprite.sortZ = (z * 1000);
        }
    }


    executeBeamWeaponLogic()
    {
        if (this.isBeam)
        {
            if (!this.beamShot)
            {
                this.beamShot = true;

                let weapPos;
                if (this.botId)
                {
                    weapPos = this.app.model.getBot(this.botId).weapRelPos[0];
                }
                else
                {
                    weapPos = this.app.controller.getRelWeapPos(0);
                }

                if (this.target && (this.targetHit || this.botId || this.physics.lockedTarget))
                {
                    let projPos = this.getReticleOffsetPosition();

                    this.physics.position = projPos;
                    this.physics.velocity = new Point3D(0,0,0);
                    // this.active = true;

                    let isAccurate = (this.targetHit || this.physics.lockedTarget) ? true : false;
                    let locked = this.physics.lockedTarget ? true : false;

                    this.entitySystem.mainView.playMultiSpriteBeamAnim(projPos,
                        weapPos, isAccurate, this.botId, locked);

                    this.delayedQueueForRemoval(1);
                }
                else
                {
                    this.physics.velocity.normalize();
                    this.physics.velocity.scale(0.1);
                    this.hoverBall = this.entitySystem.mainView.playMultiSpriteBeamAnim(this.getEntity(),
                        weapPos, this.targetHit, this.botId);
                }
            }
            else if (this.hoverBall)
            {
                if (this.lifeTime > 5)
                {
                    this.finishBeamAnim();
                }
            }
        }
    }


    finishBeamAnim()
    {
        if (this.target && !this.beamComplete)
        {
            this.beamComplete = true;

            this.physics.position = this.target.position.clone();
            this.physics.velocity = new Point3D(0,0,0);
            // this.active = true;

            this.entitySystem.mainView.finishBeamAnim(this.hoverBall, this.target);
            this.delayedQueueForRemoval(1);
        }

    }


    setProjectileRotation()
    {
        if (this.isLaser || this.isElectricity)
        {
            let p = this.getEntity().getComponent(Physics);
            let projected = this.app.layout.projectGameToScreen(p.position);
            let projected2 = this.app.layout.projectGameToScreen(p.position.add(p.velocity));
            let s = this.getEntity().getComponent(GameSprite);
            let diffVector = projected2.subtract(projected);
            s.sprite.rotation = Math.atan2(diffVector.y, diffVector.x) + Math.PI * .5;
        }
    }


    getReticleOffsetPosition()
    {
        let targetPos = this.target.position.clone();

        let projPos;
        if (!this.autoLock && !this.botId && this.targetHit) {
            let mv = this.entitySystem.mainView;
            let c = mv.mainContainer;

            if (!this.reticlePos)
            {
                this.reticlePos = c.toLocal(mv.reticleGlobalPos).clone();
            }
            let reticleProjOnTarget = this.app.layout.projectScreenToGame3D(this.reticlePos, this.target.position.z - 1);

            projPos = reticleProjOnTarget.subtract(targetPos);
            if (projPos.getLength() > this.target.collisionRadius) {
                projPos.normalize();
                projPos.scale(this.target.collisionRadius);
            }
            projPos = projPos.add(this.target.position);
        }
        else {
            projPos = targetPos;
        }

        return projPos;
    }


    updateVelocity(delta)
    {
        if (this.isBeam) return;
        let maxVelocity = this.app.model.getProjectileVelocity();

        let targetPos = this.getReticleOffsetPosition();

        // let distance = this.physics.position.distance(this.target.position);
        let distance = this.physics.position.distance(targetPos);

        let leadVector = this.target.velocity.clone();

        let leadFactor = MathUtil.clamp(distance/maxVelocity, 0, 1);

        leadVector.scale(leadFactor);
        // let projectedPosition = this.target.position.add(leadVector);
        let projectedPosition = targetPos.add(leadVector);
        let targetVector = projectedPosition.subtract(this.physics.position);

        // if (this.timeBeforeAutoTarget > 0 && !this.physics.lockedTarget && !this.isFake)
        // {
        //     let normalizedVelocity = this.physics.velocity.clone();
        //     normalizedVelocity.normalize();
        //     let normalizedDistanceVector = this.target.position.subtract(this.physics.position);
        //     normalizedDistanceVector.normalize();
        //
        //     // let dotProduct = normalizedVelocity.dotProduct(normalizedDistanceVector);
        //     // let magnitude1 = normalizedVelocity.getLength();
        //     // let magnitude2 = normalizedDistanceVector.getLength();
        //     // let magProduct = magnitude1*magnitude2
        //     //
        //     // let angle = Math.acos(normalizedVelocity.dotProduct(normalizedTargetVector));
        //     // angle *= 180/Math.PI;
        //
        //     let angle = Math.acos(normalizedVelocity.dotProduct(normalizedDistanceVector));
        //     angle *= 180/Math.PI;
        //
        //     let rad = this.target.collisionRadius;
        //     let maxAngle = Math.atan2(rad, distance);
        //     maxAngle *= 180/Math.PI;
        //
        //     // if (!this.isFake)
        //     // {
        //     //     console.log("-------------------");
        //     //     console.log("angle: " + angle);
        //     //     console.log("maxAngle: " + maxAngle);
        //     // }
        //
        //     if (angle < maxAngle && rad < distance)
        //     {
        //         console.log("autotarget enabled");
        //         this.physics.lockedTarget =  this.getTarget().getEntity();
        //         this.timeBeforeAutoTarget = 0;
        //     }
        // }

        let deviationFactor = MathUtil.clamp((this.lifeTime - this.timeBeforeAutoTarget) / 5, 0, 1);

        let guidanceLevel = .4 * deviationFactor;

        this.physics.velocity.moveTowards(targetVector, guidanceLevel);
        this.physics.velocity.normalize();

        let targetVelocity = this.target.velocity.getLength();

        let v = maxVelocity + (distance - maxVelocity) * deviationFactor;
        v = MathUtil.clamp(v, targetVelocity * 1.5, maxVelocity);
        this.physics.velocity.scale(v);
    }


    initialAcquireTarget()
    {
        if (this.botId)
        {
            this.acquireTarget();
            return;
        }

        let mv = this.entitySystem.mainView;
        let c = mv.mainContainer;
        let localPt = c.toLocal(mv.reticleGlobalPos);
        let numChildren = c.children.length;

        for (let spriteIdx = numChildren; spriteIdx > 0; spriteIdx--)
        {
            let s = c.getChildAt(spriteIdx-1);

            let width, height;
            if (!s.isDgbAnim)
            {
                width = s.width;
                height = s.height;
            }
            else // Mother of Moons
            {
                width = s.scale.x * 350;
                height = s.scale.y * 350
            }

            let dX = localPt.x - s.x;
            let dY = localPt.y - s.y;

            // let mr = (width + height) * .5;
            let hit // = ((Math.sqrt(dX * dX + dY * dY) - mr) < 0);

            let ellipseX = width * .5;
            let ellipseY = height * .5;

            let rot = s.rotation;
            let ellipseDX = Math.cos(rot)*dX + Math.sin(rot)*dY;
            let ellipseDY = Math.sin(rot)*dX - Math.cos(rot)*dY;

            // doesnt take rotation into account
            //hit = ((dX * dX)/(ellipseX * ellipseX) + (dY * dY)/(ellipseY * ellipseY) <= 1);

            // with rotation:
            hit = ((ellipseDX * ellipseDX)/(ellipseX * ellipseX) + (ellipseDY * ellipseDY)/(ellipseY * ellipseY) <= 1);

            if (hit && s.flierId)
            {
                //s.tint = 0x00ff00;
                // console.log("Target Hit");
                this.target = this.entitySystem.getEntityById(s.flierId).getComponent(Physics);
                this.targetHit = true;
                this.timeBeforeAutoTarget = 0;

                // TODO 1 done? - set projectile velocity towards the target hit point, not towards the ship Crosshair
                // TODO 2 - shootVector should not be the centre of the sprite, but the centre+(dX,dY) in game Coordinates
                this.setVelocityTowardsTarget();

                break;
            }
        }

        if (!this.target)
        {
            this.acquireTarget();
        }
    }

    setVelocityTowardsTarget()
    {
        if (this.isBeam) return;

        let projPos = this.getReticleOffsetPosition();
        let shootVector = projPos.subtract(this.physics.position);
        // let shootVector = this.target.position.subtract(this.physics.position);
        shootVector.normalize();
        shootVector.scale(this.app.model.getProjectileVelocity());
        this.physics.setVelocity(shootVector.x, shootVector.y, shootVector.z);
        return shootVector;
    }


    acquireTarget()
    {
        let targets = this.entitySystem.getEntitiesByType(C_Entity.FLIER);

        let normalizedVelocity = this.physics.velocity.clone();
        normalizedVelocity.normalize();
        let pos = this.physics.position;
        let minAngle = Number.POSITIVE_INFINITY;

        for (let targetName in targets)
        {
            let p = targets[targetName].getComponent(Physics);
            let targetVector = p.position.subtract(pos);
            let normalizedTargetVector = targetVector.clone();
            normalizedTargetVector.normalize();

            // let angle = Math.acos(normalizedVelocity.dotProduct(normalizedTargetVector)) * targetVector.getLength();
            let angle = Math.acos(normalizedVelocity.dotProduct(normalizedTargetVector));

            if (angle < minAngle)
            {
                this.target = p;
                minAngle = angle;
            }
        }
    }

}


export default ProjectileLogic;